export default {
    country: 'País',
    countryPlaceHolder: 'Selecciona un País',
    noCountry: 'País no encontrado',
    noCountries: 'Países no encontrado',
};